<template>
  <div style="margin: 20px 15px 20px 15px; padding: 30px 25px 30px 25px; background-color: white">
    <el-form :inline="true">
      <el-form-item>
        <el-autocomplete style="margin-right:5px;" placeholder="请输入交易对" v-model="formData.pair" :fetch-suggestions="querySearchAsync" @change="findOne"></el-autocomplete>
      </el-form-item>
<!--      <el-form-item label="交易对：">-->
<!--        <el-input v-model="formData.pair" placeholder="请输入交易对" clearable></el-input>-->
<!--      </el-form-item>-->
      <el-form-item label="盘口订单数量：">
        <el-input v-model="formData.number" placeholder="盘口铺单数量"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :plain="true" @click="queryPairMarketDelegationDistinguish">查询</el-button>
      </el-form-item>
      <el-form-item label="轮询开关：">
        <el-switch
            v-model="polling"
            active-text="开"
            inactive-text="关">
        </el-switch>
      </el-form-item>
    </el-form>

    <el-form style="text-align: right">
      <el-form-item>
        <el-button type="success" icon="el-icon-s-unfold" :plain="true" @click="bidAsk" style="text-align: right">买卖盘口</el-button>
        <el-button type="success" icon="el-icon-s-unfold" :plain="true" @click="bidOnly" style="text-align: right">买方盘口</el-button>
        <el-button type="success" icon="el-icon-s-unfold" :plain="true" @click="askOnly" style="text-align: right">卖方盘口</el-button>
      </el-form-item>
    </el-form>

    <div style="height: auto; border: 1px solid #eee; width: auto" v-if="isShow === 0">

      <el-container style="height: 550px">
        <el-header style="text-align: left; font-size: 15px; background-color: #F56C6C; color: #333; line-height: 60px; width: 100%">
          <span>卖方订单</span>
        </el-header>


        <el-main>
          <el-table :data="askData" style="width: 100%;" height="450" id="chatContainer">
            <el-table-column prop="" label="" width="35">
              <template slot-scope="scope">
                <i class="el-icon-star-on" v-if="scope.row.maker === true"></i>
              </template>
            </el-table-column>
            <el-table-column prop="price" :label=priceName></el-table-column>
            <el-table-column prop="stratumAmount" :label=amountName></el-table-column>
            <el-table-column prop="frozenBalance" :label=valueName></el-table-column>
            <el-table-column prop="totalAnchorCoin" :label=totalAnchorCoinName></el-table-column>
            <el-table-column prop="totalFrozenBalance" :label=totalFrozenBalanceName></el-table-column>
            <el-table-column prop="platformUserCoinAmount" :label=platformUserCoinAmountName></el-table-column>
            <el-table-column prop="nonPlatformUserCoinAmount" :label=nonPlatformUserCoinAmountName></el-table-column>
            <el-table-column prop="availableAnchorCoin" :label=availableAnchorCoinName></el-table-column>
            <el-table-column prop="availableMeasureCoin" :label=availableMeasureCoinName></el-table-column>
            <el-table-column prop="userId" label="用户ID"></el-table-column>
<!--            <el-table-column prop="src" label="下单来源" width="150"></el-table-column>-->
<!--            <el-table-column prop="orderId" label="订单ID" width="220"></el-table-column>-->
            <el-table-column prop="" label="更多" style="width: 80px">
              <template slot-scope="scope">
                <el-popover
                    placement="top-start"
                    trigger="hover">

                  <el-form ref="form" :model="scope.row">
                    <el-form-item>
                      <span>委托订单: {{ scope.row.orderId }}</span>
                    </el-form-item>
                    <el-form-item>
                      <span>下单来源: {{ scope.row.src }}</span>
                    </el-form-item>
                    <el-form-item>
                      <span>下单时间: {{ scope.row.createdTime }}</span>
                    </el-form-item>
                    <el-form-item>
                      <span>更新时间: {{ scope.row.updateTime }}</span>
                    </el-form-item>
                  </el-form>

                  <el-button slot="reference">...</el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-container>
      <el-header style="text-align: left; font-size: 15px; background-color: #409EFF; color: #333; line-height: 60px; width: 100%">
        <span>当前交易对：{{ pair }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 最新成交价：{{ currentPrice }}</span>
      </el-header>
      <el-container style="height: 550px">
        <el-main>
          <el-table :data="bidData" style="width: 100%" height="450">
            <el-table-column prop="" label="" width="35">-->
              <template slot-scope="scope">
                <i class="el-icon-star-on" v-if="scope.row.maker === true"></i>
              </template>
            </el-table-column>
            <el-table-column prop="price" :label=priceName></el-table-column>
            <el-table-column prop="stratumAmount" :label=amountName></el-table-column>
            <el-table-column prop="frozenBalance" :label=valueName></el-table-column>
            <el-table-column prop="totalAnchorCoin" :label=totalAnchorCoinName></el-table-column>
            <el-table-column prop="totalFrozenBalance" :label=totalFrozenBalanceName></el-table-column>
            <el-table-column prop="platformUserCoinAmount" :label=platformUserCoinAmountName></el-table-column>
            <el-table-column prop="nonPlatformUserCoinAmount" :label=nonPlatformUserCoinAmountName></el-table-column>
            <el-table-column prop="availableAnchorCoin" :label=availableAnchorCoinName></el-table-column>
            <el-table-column prop="availableMeasureCoin" :label=availableMeasureCoinName></el-table-column>
            <el-table-column prop="userId" label="用户ID"></el-table-column>
<!--            <el-table-column prop="src" label="下单来源" width="150"></el-table-column>-->
<!--            <el-table-column prop="orderId" label="订单ID" width="220"></el-table-column>-->

            <el-table-column prop="" label="更多" style="width: 80px">
              <template slot-scope="scope">
                <el-popover
                    placement="top-start"
                    trigger="hover">
                  <el-form ref="form" :model="scope.row">

                    <el-form-item>
                      <el-form-item>
                        <span>委托订单: {{ scope.row.orderId }}</span>
                      </el-form-item>
                      <span>下单来源: {{ scope.row.src }}</span>
                    </el-form-item>
                    <el-form-item>
                      <span>下单时间: {{ scope.row.createdTime }}</span>
                    </el-form-item>
                    <el-form-item>
                      <span>更新时间: {{ scope.row.updateTime }}</span>
                    </el-form-item>
                  </el-form>

                  <el-button slot="reference">...</el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
        <el-header style="text-align: left; font-size: 15px; background-color: #67C23A; color: #333; line-height: 60px; width: 100%">
          <span>买方订单</span>
        </el-header>
      </el-container>

    </div>

    <div style="height: auto; border: 1px solid #eee; width: auto" v-if="isShow === 1">
      <el-header style="text-align: left; font-size: 15px; background-color: #409EFF; color: #333; line-height: 60px; width: 100%">
        <span>当前交易对：{{ pair }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 最新成交价：{{ currentPrice }}</span>
      </el-header>
      <el-container style="height: 1060px">
        <el-main>
          <el-table :data="bidData" style="width: 100%" height="1010">
            <el-table-column prop="" label="" width="35">-->
              <template slot-scope="scope">
                <i class="el-icon-star-on" v-if="scope.row.maker === true"></i>
              </template>
            </el-table-column>
            <el-table-column prop="price" :label=priceName></el-table-column>
            <el-table-column prop="stratumAmount" :label=amountName></el-table-column>
            <el-table-column prop="frozenBalance" :label=valueName></el-table-column>
            <el-table-column prop="totalAnchorCoin" :label=totalAnchorCoinName></el-table-column>
            <el-table-column prop="totalFrozenBalance" :label=totalFrozenBalanceName></el-table-column>
            <el-table-column prop="platformUserCoinAmount" :label=platformUserCoinAmountName></el-table-column>
            <el-table-column prop="nonPlatformUserCoinAmount" :label=nonPlatformUserCoinAmountName></el-table-column>
            <el-table-column prop="availableAnchorCoin" :label=availableAnchorCoinName></el-table-column>
            <el-table-column prop="availableMeasureCoin" :label=availableMeasureCoinName></el-table-column>
            <el-table-column prop="userId" label="用户ID"></el-table-column>
<!--            <el-table-column prop="src" label="下单来源" width="150"></el-table-column>-->
<!--            <el-table-column prop="orderId" label="订单ID" width="220"></el-table-column>-->
            <el-table-column prop="" label="更多" style="width: 80px">
              <template slot-scope="scope">
                <el-popover
                    placement="top-start"
                    trigger="hover">
                  <el-form ref="form" :model="scope.row">

                    <el-form-item>
                      <span>委托订单: {{ scope.row.orderId }}</span>
                    </el-form-item>
                    <el-form-item>
                      <span>下单来源: {{ scope.row.src }}</span>
                    </el-form-item>
                    <el-form-item>
                      <span>下单时间: {{ scope.row.createdTime }}</span>
                    </el-form-item>
                    <el-form-item>
                      <span>更新时间: {{ scope.row.updateTime }}</span>
                    </el-form-item>
                  </el-form>

                  <el-button slot="reference">...</el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-container>
    </div>

    <div style="height: auto; border: 1px solid #eee; width: auto" v-if="isShow === 2">
      <el-header style="text-align: left; font-size: 15px; background-color: #409EFF; color: #333; line-height: 60px; width: 100%">
        <span>当前交易对：{{ pair }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 最新成交价：{{ currentPrice }}</span>
      </el-header>
      <el-container style="height: 1060px">
        <el-main>
          <el-table :data="askData" style="width: 100%" height="1010">
            <el-table-column prop="" label="" width="35">-->
              <template slot-scope="scope">
                <i class="el-icon-star-on" v-if="scope.row.maker === true"></i>
              </template>
            </el-table-column>
            <el-table-column prop="price" :label=priceName></el-table-column>
            <el-table-column prop="stratumAmount" :label=amountName></el-table-column>
            <el-table-column prop="frozenBalance" :label=valueName></el-table-column>
            <el-table-column prop="totalAnchorCoin" :label=totalAnchorCoinName></el-table-column>
            <el-table-column prop="totalFrozenBalance" :label=totalFrozenBalanceName></el-table-column>
            <el-table-column prop="platformUserCoinAmount" :label=platformUserCoinAmountName></el-table-column>
            <el-table-column prop="nonPlatformUserCoinAmount" :label=nonPlatformUserCoinAmountName></el-table-column>
            <el-table-column prop="availableAnchorCoin" :label=availableAnchorCoinName></el-table-column>
            <el-table-column prop="availableMeasureCoin" :label=availableMeasureCoinName></el-table-column>
            <el-table-column prop="userId" label="用户ID"></el-table-column>
<!--            <el-table-column prop="src" label="下单来源" width="150"></el-table-column>-->
<!--            <el-table-column prop="orderId" label="订单ID" width="220"></el-table-column>-->
            <el-table-column prop="" label="更多" style="width: 80px">
              <template slot-scope="scope">
                <el-popover
                    placement="top-start"
                    trigger="hover">
                  <el-form ref="form" :model="scope.row">

                    <el-form-item>
                      <span>委托订单: {{ scope.row.orderId }}</span>
                    </el-form-item>
                    <el-form-item>
                      <span>下单来源: {{ scope.row.src }}</span>
                    </el-form-item>
                    <el-form-item>
                      <span>下单时间: {{ scope.row.createdTime }}</span>
                    </el-form-item>
                    <el-form-item>
                      <span>更新时间: {{ scope.row.updateTime }}</span>
                    </el-form-item>
                  </el-form>

                  <el-button slot="reference">...</el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-container>
    </div>

  </div>
</template>

<script>
import utils from './utils'
import '@/entries/Machine/cache'
import {mapActions, mapState} from "vuex";

export default {
  name: "index",
  provide(){
    return {
      reload: this.reload
    }
  },

  data(){
    return{
      priceName:"价格",
      amountName:"数量",
      valueName:"价值",
      totalAnchorCoinName:"代币累计",
      totalFrozenBalanceName:"累计价值",
      availableAnchorCoinName:"可用代币量",
      availableMeasureCoinName:"可用计价币量",
      platformUserCoinAmountName:"平台用户代币累计",
      nonPlatformUserCoinAmountName:"非平台用户代币累计",
      isShow: 0,
      showSwitch: true,
      polling: false,
      pair:'',
      currentPrice:'',
      bidData: [],
      askData: [],
      bidDepth: [],
      askDepth: [],
      formData:{
        pair:'',
        number: 20
      },
      booData:{
        "frozenBalance" :"frozenBalance",
        "totalAnchorCoin" :"totalAnchorCoin",
        "totalFrozenBalance" :"totalFrozenBalance",
        "platformUserCoinAmount" :"platformUserCoinAmount",
        "nonPlatformUserCoinAmount" :"nonPlatformUserCoinAmount",
        "availableAnchorCoin" :"availableAnchorCoin",
        "availableMeasureCoin" :"availableMeasureCoin",
      }
    }
  },

  computed: {
    ...mapState('quotationCache', ['configurations']),
  },

  methods: {
    ...mapActions('quotationCache', ['queryConfigurations']),

    bidAsk () { this.isShow = 0 },

    bidOnly () { this.isShow = 1 },

    askOnly () { this.isShow = 2 },

    createStateFilter(queryString) {
      return (state) => {
        return (state.pair.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },

    deepCopy(source) {
      let sourceCopy = source instanceof Array ? [] : {};
      for (let item in source) {
        sourceCopy[item] = typeof source[item] === 'object' ? this.deepCopy(source[item]) : source[item];
      }
      return sourceCopy;
    },

    querySearchAsync(queryString, cb) {
      let restaurants = this.configurations;
      let results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      let suggest = [];
      for(let index in results) {
        suggest.push({'value':results[index].pair});
      }
      cb(suggest);
    },

    findOne() {
      let len = this.configurations.length;
      this.configuration = {};
      for (let i = 0; i < len; i++) {
        if (this.pair === this.configurations[i].pair) {
          this.configuration = this.deepCopy(this.configurations[i]);
          return;
        }
      }
    },

    queryPairMarketDelegationDistinguish(){

      if (this.formData.pair === '' || this.formData.pair.split("_").length !== 2){ return }

      if (this.formData.pair.split("_").length !== 2 ) { return; }

      utils.queryPairMarketDelegationDistinguish(this.formData).then((response)=>{
        this.pair = response.data.pair
        let pairSplit = this.pair.split("_")
        this.priceName = "价格(" + pairSplit[1] + ")"
        this.amountName = "数量(" + pairSplit[0] + ")"
        this.valueName = "价值(" + pairSplit[1] + ")"
        this.totalAnchorCoinName = "代币累计(" + pairSplit[0] + ")"
        this.totalFrozenBalanceName = "累计价值(" + pairSplit[1] + ")"
        this.availableAnchorCoinName = "可用代币量(" + pairSplit[0] + ")"
        this.availableMeasureCoinName = "可用计价币量(" + pairSplit[1] + ")"
        this.platformUserCoinAmountName = "平台用户代币累计(" + pairSplit[0] + ")"
        this.nonPlatformUserCoinAmountName = "非平台用户代币累计(" + pairSplit[0] + ")"
        this.currentPrice = response.data.currentPrice
        let bidData = response.data.originBids
        for (let i in bidData){
          let item = bidData[i]
          for (let key in item){
              if (this.booData.hasOwnProperty(key) && parseFloat(item[key]) > 0.001 ){
                item[key] = item[key].toLocaleString()
            }
          }
          bidData[i].updateTime = utils.getLocalTime(bidData[i].updateTime)
          bidData[i].createdTime = utils.getLocalTime(bidData[i].createdTime)
        }
        let askData = response.data.originAsks
        for (let i in askData){
          let item = askData[i]
          for (let key in item){
            if (this.booData.hasOwnProperty(key) && parseFloat(item[key]) > 0.001 ){
              item[key] = item[key].toLocaleString()
            }
          }
          askData[i].updateTime = utils.getLocalTime(askData[i].updateTime)
          askData[i].createdTime = utils.getLocalTime(askData[i].createdTime)
        }
        this.bidData = bidData
        this.askData = askData
        this.bidDepth = response.data.mergeBids
        this.askDepth = response.data.mergeAsks
      })
    },

    showMergeData(){
      this.showSwitch = false
    },
    showOriginData(){
      this.showSwitch = true
    },
  },

  watch: {
    'polling'(val){
      if (val === true){
        this.timer = window.setInterval(() => {
          setTimeout(this.queryPairMarketDelegationDistinguish, 0);
        }, 5000);
      } else {
        window.clearInterval(this.timer)
      }
    },
    // 'askData'(val) {
    //   this.$nextTick(() => {
    //     let container = this.$el.querySelector('.el-table__body-wrapper');
    //     container.scrollTop = container.scrollHeight;
    //   })
    // },
  },

  created() {
    this.queryConfigurations()
  },

  beforeRouteLeave(to, form, next) {
    next()
    this.polling = false
    window.clearInterval(this.timer)
  },
  destroyed() {
    this.polling = false
    window.clearInterval(this.timer)
  },
}
</script>

<style scoped>

[v-cloak] {
  display: none;
}

</style>